module.exports = __webpack_public_path__ + "assets/images/364b9fe04ba4be55f5a40bc52c83b2c4.png";